import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Globe, ChevronDown } from 'lucide-react';
import { trackLanguageChange } from '@/lib/analytics';

export default function LanguageSelector() {
  const { currentLang, switchLanguage, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const current = languages.find(l => l.code === currentLang) || languages[0];

  return (
    <div className="relative" ref={ref} data-testid="language-selector">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 px-2 py-1 rounded-md text-xs text-slate-400 hover:text-slate-200 hover:bg-slate-800/50 transition-colors"
        data-testid="language-selector-btn"
      >
        <Globe className="w-3.5 h-3.5" />
        <span className="uppercase font-medium">{current.code}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 w-44 bg-slate-900 border border-slate-700 rounded-xl shadow-xl z-50 py-1 max-h-80 overflow-y-auto" data-testid="language-dropdown">
          {languages.map(lang => (
            <button
              key={lang.code}
              onClick={() => { switchLanguage(lang.code); trackLanguageChange(lang.code); setOpen(false); }}
              className={`w-full text-left px-3 py-1.5 text-xs flex items-center gap-2 hover:bg-slate-800 transition-colors ${currentLang === lang.code ? 'text-emerald-400 bg-slate-800/50' : 'text-slate-400'}`}
              data-testid={`lang-option-${lang.code}`}
            >
              <span className="text-sm">{lang.flag}</span>
              <span>{lang.name}</span>
              <span className="ml-auto uppercase text-[10px] text-slate-600">{lang.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
